<div class="search__body">
    <form [formGroup]="form" class="search__form" (ngSubmit)="search()">
         <button class="search__button search__button--type--submit" type="submit">
            <app-icon name="search-20" size="20"></app-icon>
        </button>
        <input
            class="search__input"
            name="search"
            aria-label="Ricerca del sito"
            type="text"
            placeholder="Cerca un prodotto"
            autocomplete="off"
            formControlName="query"
            (keydown.escape)="escape.next()"
            (focus)="openSuggestion()"
            #input
        >
       <!-- <button
            class="search__button search__button--type--close"
            type="button"
            (click)="closeButtonClick.next()"
        >
            <app-icon name="cross-20" size="20"></app-icon>
        </button> -->
        <div class="search__border"></div>
    </form>

    <!-- Da attivare solo se si vogliono ripristinare i suggerimenti
    <div class="search__suggestions suggestions suggestions--location--{{ location }}">
        <ul class="suggestions__list">
            <li *ngFor="let product of suggestedProducts" class="suggestions__item">
                <div class="suggestions__item-image product-image">
                    <div class="product-image__body">
                        <img class="product-image__img" [src]="product.cdn_url" alt="">
                    </div>
                </div>

                <div class="suggestions__item-info">
                    <a [routerLink]="root.product(product)" class="suggestions__item-name" (click)="closeSuggestion()">
                        {{ product.descart }}
                    </a>
                    <div class="suggestions__item-meta">Codice: {{ product.codart }} </div>
                </div>

                <ng-container *ngIf="accountService.showPrices$ | async">
                    <div class="suggestions__item-price" *ngIf="!priceService.hasDiscount(product)">
                        {{ priceService.prezzoArticolo(product) | currencyFormat }}
                        <div *ngIf="store.price == 'b2b'" style="font-size: 12px; color: red;">IVA esclusa</div>
                    </div>
    
                    <div class="suggestions__item-price" *ngIf="priceService.hasDiscount(product)">
                        <div class="suggestions__item-price-old">{{ priceService.prezzoArticoloOld(product) | currencyFormat }}</div>
                        <div class="suggestions__item-price-new">{{ priceService.prezzoArticolo(product) | currencyFormat }}</div>
                        <div *ngIf="store.price == 'b2b'" style="font-size: 12px; color: red;">IVA esclusa</div>
                    </div>
  
                    <div class="suggestions__item-actions">
                        <button
                            type="button"
                            title="Aggiungi al carrello"
                            class="btn btn-primary-darken btn-sm btn-svg-icon"
                            [class.btn-loading]="addedToCartProducts.includes(product)"
                            (click)="addToCart(product)"
                        >
                            <app-icon name="cart-16" size="16"></app-icon>
                        </button>
                    </div>
                </ng-container>
            </li>
        </ul>
    </div> -->
</div>
